export default "__VITE_ASSET__Ca_8JCfa__"